import { Badge, BadgeVariant } from '@moment/design-system-ui/badge'
import { useMemo } from 'react'

const VARIANT_BY_LABEL: Record<string, BadgeVariant> = {
  // Fixed income
  Treasury: BadgeVariant.Success,
  Municipal: BadgeVariant.Warning,
  Corporate: BadgeVariant.Processing,
  Agency: BadgeVariant.Danger,
  MMF: BadgeVariant.Special,
  // Equity
  Stock: BadgeVariant.Success,
  MF: BadgeVariant.Warning,
  ADR: BadgeVariant.Processing,
  ETF: BadgeVariant.Special,
}

interface AssetClassBadgeProps {
  label: string
  className?: string
}

export function AssetClassBadge({
  label,
  className = '',
}: AssetClassBadgeProps) {
  const variant = useMemo(
    () => VARIANT_BY_LABEL[label] ?? BadgeVariant.Neutral,
    [label],
  )
  return (
    <Badge className={className} variant={variant}>
      {label}
    </Badge>
  )
}
